import $ from "jquery";
import ScrollMagic from "scrollmagic";

var scrollController = new ScrollMagic.Controller();

$(".reveal").each(function () {
  var $self = $(this);
  var options_scroll = {
    triggerElement: $self[0],
    // triggerHook: .6,
    triggerHook: "onEnter",
    offset: 50,
  };

  new ScrollMagic.Scene(options_scroll)
    .setClassToggle($self[0], "is-active")
    .addTo(scrollController);
});

var reveal_check = $(".reveal--image").length;
if (reveal_check >= 1) {
  $(".reveal--image").each(function () {
    var $self = $(this);
    var options_scroll = {
      triggerElement: $self[0],
      triggerHook: 0.5,
      // triggerHook: 'onEnter',
      offset: 50,
    };
    new ScrollMagic.Scene(options_scroll)
      .setClassToggle($self[0], "svg-start")
      .reverse(false)
      .addTo(scrollController);
  });
}

$(document).ready(function () {
  // SCROLLIMAGE
  var check = $(".scroll--image-img").length;
  if (check >= 1) {
    var section_height = $(".section--interview").height();
    let img_height = $(".scroll--image-img").height();
    // console.log(section_height, img_height);

    var scroll_height = section_height;
    var controller_image = new ScrollMagic.Controller();
    $(function () {
      // wait for document ready
      // build scene
      var scene = new ScrollMagic.Scene({
        triggerElement: ".scroll--image-img",
        triggerHook: 0.1,
        duration: scroll_height - img_height,
      })
        .setPin(".scroll--image-img")
        .addTo(controller_image);
    });
  }
});
